module.exports = __webpack_public_path__ + "static/media/Events-02.7feb05c2.webp";